<template>
  <el-dialog
    :title="$t('audit.auditInfo')"
    :visible.sync="visible"
    width="50%"
    @close="clearForm"
  >
    <el-form ref="form" :model="auditInfo" label-width="120px">
      <el-form-item :label="$t('audit.auditStatus')" prop="state" required>
        <el-select
          v-model="auditInfo.state"
          :placeholder="$t('audit.selectAuditStatus')"
          style="width:100%"
          @change="handleStateChange"
        >
          <el-option
            :label="$t('audit.agree')"
            value="1100"
          />
          <el-option
            :label="$t('audit.reject')"
            value="1200"
          />
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('audit.reason')" prop="remark" required>
        <el-input
          v-model="auditInfo.remark"
          type="textarea"
          :placeholder="$t('audit.inputReason')"
          :rows="4"
        />
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="clearForm">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submit">{{ $t('common.submit') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'Audit',
  props: {
    callBackListener: {
      type: String,
      default: ''
    },
    callBackFunction: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      auditInfo: {
        state: '',
        remark: ''
      }
    }
  },
  methods: {
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    clearForm() {
      this.auditInfo = {
        state: '',
        remark: ''
      }
      this.$refs.form.resetFields()
      this.close()
    },
    handleStateChange(val) {
      if (val === '1100') {
        this.auditInfo.remark = this.$t('audit.agree')
      } else {
        this.auditInfo.remark = ''
      }
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        
        if (this.callBackListener && this.callBackFunction) {
          console.log(this.callBackListener);
          this.$emit(this.callBackFunction, this.auditInfo)
        }
        this.clearForm()
        this.$message.success(this.$t('common.auditSuccess'))
      })
    }
  }
}
</script>